import { apiFetch } from "./apiClient";

export async function getRoomsWithHierarchy() {
  const res = await apiFetch(`/api/services/service/rooms`);
  if (!res.ok) {
    throw new Error("Failed to fetch rooms");
  }
  return res.json();
}
